/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrCheckboxListModule } from './igr-checkbox-list-module';
import { IgrGridColumnFilterOptions } from './igr-grid-column-filter-options';
import { GridColumnFilterOptions } from './GridColumnFilterOptions';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridColumnFilterOptionsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnFilterOptionsModule() {
    }
    IgrGridColumnFilterOptionsModule.register = function () {
        IgrCheckboxListModule.register();
        TypeRegistrar.registerCons('IgrGridColumnFilterOptions', IgrGridColumnFilterOptions);
        TypeRegistrar.registerCons('IgrGridColumnFilterOptions', IgrGridColumnFilterOptions);
        TypeRegistrar.register('GridColumnFilterOptions', GridColumnFilterOptions.$type);
    };
    return IgrGridColumnFilterOptionsModule;
}());
export { IgrGridColumnFilterOptionsModule };
//# sourceMappingURL=igr-grid-column-filter-options-module.js.map
